import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";

class ModalDialog extends Component {
  state = {};
  render() {
    return (
      <Modal
      id="modalDialogId"
        show={this.props.show}
        onHide={this.props.handleClose}
        size={this.props.modelSizeWindow ? this.props.modelSizeWindow : "sm"}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        centered="true"
        className={this.props.modalClassName}
      >
        <Modal.Header className={this.props.modalHeaderClass ? this.props.modalHeaderClass : ""}>
          <Modal.Title
            className="modalTitle"
            id="contained-modal-title-vcenter"
          >
            {this.props.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{this.props.message}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button 
            variant="secondary" 
            id={this.props.secondaryButtonId}
            onClick={this.props.handleClose}
            className={"btn-secondary confirmPrivacyUpdateBtn"}
          >
          {this.props.handleButtonClose!== ""?this.props.handleButtonClose: "Close"}
          </Button>
          <Button
            className={"ModalButtonClass confirmPrivacyUpdateBtn " + this.props.className}
            variant="primary"
            id={this.props.primaryButtonId}
            onClick={this.props.handleSubmitClose}
          >
            {this.props.handleButtonName}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ModalDialog;
